import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components/Modals/Modal";
import { Spinner } from "@/components/Spinner/Spinner";

export interface EnrichAnywayProgressModalProps {
	isOpened: boolean;
	count: number;
	/** Applies the PREC-3544 "Last added/enriched" sort so fresh results surface on top. */
	onSortByEnriched: () => void;
	onClose: () => void;
}

/**
 * Post-confirm progress modal (PREC-3536 Phase 5, mirrors the Find-person "Finding people"
 * pattern): enrichment runs in the background; offer the last-added/enriched sort or keep
 * the current sorting.
 */
export const EnrichAnywayProgressModal: FunctionComponent<EnrichAnywayProgressModalProps> = ({
	isOpened,
	count,
	onSortByEnriched,
	onClose,
}) => {
	const { t } = useTranslation();

	// The shared Modal keeps its dialog mounted when closed; unmount fully instead.
	if (!isOpened) {
		return null;
	}

	return (
		<Modal
			cancelButtonText={t("inbox.enrichAnywayFlow.keepSorting")}
			handleClose={onClose}
			handleSave={onSortByEnriched}
			isOpened={isOpened}
			size="sm"
			submitButtonText={t("inbox.enrichAnywayFlow.sortAction")}
			title={t("inbox.enrichAnywayFlow.progressTitle", { count })}
		>
			<div className="flex items-start gap-3" data-test="enrich-anyway-progress">
				<Spinner color="#6B7280" />
				<p className="text-sm text-text-meta">{t("inbox.enrichAnywayFlow.progressDescription")}</p>
			</div>
		</Modal>
	);
};
